export const MEGA_MENU_CTA = "Explore popular package destinations!";
